import React from "react";

const About = () => {
  return (
    <section className="py-8 font-[Quicksand] text-gray-800 leading-relaxed px-4 md:px-10">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start gap-8">
        {/* Kiri: Teks */}
        <div className="md:w-2/3 space-y-5">
          <p className="text-lg">
            <strong className="text-2xl font-bold text-gray-900">Our promise to your dog</strong>
          </p>

          <p className="text-base">
            Led by <strong>Rhylee</strong> — with 6+ years in professional
            grooming and salon management — <strong>Furlissimo</strong> is built
            on a foundation of care, skill, and trust. Since taking ownership in
            2025, Rhylee has shaped a team of groomers each holding a
            Certificate III in Animal Care Services or equivalent, bringing
            together technical excellence and genuine warmth.
          </p>

          <p className="text-lg font-semibold text-gray-900">
            Our promise to your dog
          </p>
          <ul className="list-disc list-inside text-base text-gray-700 space-y-2">
            <li>
              <strong>A calm, welcoming environment:</strong> We know grooming
              can be stressful — we aim to erase that.
            </li>
            <li>
              <strong>Tailored care:</strong> Every dog gets an individual
              approach, from coat prep to final finish.
            </li>
            <li>
              <strong>Transparent communication:</strong> If your pup needs
              extra care, we’ll let you know and work through options together.
            </li>
            <li>
              <strong>Apprenticeship-friendly:</strong> We’re passionate about
              training new groomers — we invest in people, not just styles.
            </li>
          </ul>

          <p className="text-lg font-semibold text-gray-900">Why choose us</p>
          <p className="text-base">
            We pride ourselves on being more than a grooming service — we’re a
            community of dog lovers dedicated to bringing out the best in every
            coat and every character.
          </p>

          <p className="text-base">
            The salon has the feel of a boutique café for pets — stylish yet
            down-to-earth, where wagging tails and friendly faces set the tone.
            Every appointment is a chance to create comfort, confidence, and a
            touch of joy.
          </p>

          <p className="text-base">
            If you have any questions, feel free to contact Rhylee at{" "}
            <a
              href="mailto:admin@furlissimo.com.au"
              className="text-blue-600 hover:underline font-medium"
            >
              admin@furlissimo.com.au
            </a>
            .
          </p>
        </div>

        {/* Kanan: Kotak gambar */}
        <div
          className="w-full md:w-1/3 rounded-2xl shadow-md bg-cover bg-center"
          style={{
            backgroundImage: "url('/assets/images/image1.png')",
            height: "500px",
          }}
        ></div>
      </div>
    </section>
  );
};

export default About;
